var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg09(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.43 126.59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.54 76a31 31 0 01-22.43 9.43q-16.39 0-26.25-11.26T0 43.75a47.41 47.41 0 015.31-22.3 39 39 0 0114.83-15.8A41.09 41.09 0 0141.55 0 39.36 39.36 0 0163.3 6.12 40.25 40.25 0 0178.08 23.7 63.1 63.1 0 0183.43 50v9.09q0 30.93-15.38 48.6t-43.58 18.82l-6 .08v-20.47l5.43-.09Q55.91 104.59 58.54 76zm-16.4-9.35a17.18 17.18 0 0010.24-3.06 20.5 20.5 0 006.5-7.39V46.05q0-12.49-4.76-19.37a14.76 14.76 0 00-12.74-6.88q-7.4 0-12.15 6.75t-4.76 17q0 10.11 4.63 16.61a15.09 15.09 0 0013.04 6.45z",
    fill: "#fff"
  })));
}

Svg09.displayName = '09';
export default Svg09;